import { IIntegrationPartnerManager, IntegrationPartnerManagerFactory } from '../integrationPartnerAbstraction';
import { useCallback, useEffect, useRef, useState } from 'react';
import { IConfigServiceInjectedProps } from '$State/ConfigFreezerService';
import { IIntegrationPartnerDataInjectedProps } from '$State/IntegrationPartnerDataFreezerService';
import { IUserManagementServiceInjectedProps } from '../../state/UserManagementFreezerService';

type UseGeotabSetupProps = IConfigServiceInjectedProps & IIntegrationPartnerDataInjectedProps & IUserManagementServiceInjectedProps;

const useIntegrationSetup = (props: UseGeotabSetupProps) => {
    const [isIntegrationReady, setIsIntegrationReady] = useState(false);
    const [manager, setManager] = useState<IIntegrationPartnerManager | null>(null);
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const setupIntegrationPartner = useCallback((): void => {
        try {
            const integrationManager = IntegrationPartnerManagerFactory.getIntegrationPartnerService();

            if (!integrationManager) {
                console.error('[IntegrationManagerSetup] Manager is null or undefined');
                return;
            }

            setManager(integrationManager);
        } catch (e) {
            console.error('[IntegrationManagerSetup] Failed', e);
            setManager(null);
        }
    }, []);

    useEffect(() => {
        if (manager && isMountedRef.current) {
            props.integrationPartnerData.setIntegrationPartnerManager(manager);
            setIsIntegrationReady(true);
        } else if (isMountedRef.current) {
            setIsIntegrationReady(false);
        }
    }, [manager, props]);

    return { isIntegrationReady, setupIntegrationPartner };
};

export { useIntegrationSetup };
